import React, { useCallback, useState } from 'react';

import {
  FiMenu,
  FiShoppingCart,
  FiUser,
  FiShoppingBag,
  FiHeart,
} from 'react-icons/fi';

import { AiOutlineClose } from 'react-icons/ai';

import { FaSignOutAlt } from 'react-icons/fa';

import { NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  Root,
  ContainerBGMenu,
  ContainerMenuLeft,
  ContainerMenuRight,
  ContainerMenu,
  MenuHeader,
  MenuUser,
  MenuName,
  MenuShortCuts,
  MenuShortCutItem,
  MenuFooter,
  MenuAppVersion,
  MenuUserLogout,
  UserLogoutBtn,
  Content,
  ContentHeader,
  NavMenu,
  BadgeNumber,
  Button,
  Container,
  ContainerProducts,
} from './styles';

import { StoreState } from '../../store/createStore';
import ProductList from '../../components/ProductList';
import { signOut } from '../../store/modules/auth/actions';

const MobileHome: React.FC = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const dispatch = useDispatch();

  const { user } = useSelector((state: StoreState) => state.auth);

  const {
    checkout: { items_count },
  } = useSelector((state: StoreState) => state.checkout);

  const handledOpenMenu = useCallback(() => {
    setOpenMenu(true);
  }, []);


  const handledSigout = useCallback(() => {
    dispatch(signOut());
  }, [dispatch]);

  return (
    <Root>
      <ContainerBGMenu open={openMenu}>
        <ContainerMenuLeft>
          <ContainerMenu>
            <MenuHeader>
              <MenuUser>
                <FiUser size={26} color="#FFF" />
                <MenuName>
                  <span>Olá</span>
                  <strong>{user.data.first_name}</strong>
                </MenuName>
                <AiOutlineClose
                  size={22}
                  color="#FFF"
                  onClick={() => setOpenMenu(!openMenu)}
                />
              </MenuUser>
            </MenuHeader>
            <MenuShortCuts>
              <MenuShortCutItem>
                <FiShoppingBag size={16} />
                <span>Meus pedidos</span>
              </MenuShortCutItem>
              <MenuShortCutItem>
                <FiHeart size={16} />
                <span>Favoritos</span>
              </MenuShortCutItem>
              <MenuShortCutItem>
                <FiUser size={16} />
                <span>Mnha conta</span>
              </MenuShortCutItem>
            </MenuShortCuts>
            <MenuFooter>
              <MenuAppVersion>
                <span>Agencia Conecto</span>
                v1.0.0
              </MenuAppVersion>
              <MenuUserLogout>
                <UserLogoutBtn onClick={handledSigout}>
                  <span>Sair</span>
                  <FaSignOutAlt size={18} color="#FF9b00" />
                </UserLogoutBtn>
              </MenuUserLogout>
            </MenuFooter>
          </ContainerMenu>
        </ContainerMenuLeft>
        <ContainerMenuRight onClick={() => setOpenMenu(!openMenu)} />
      </ContainerBGMenu>
      <Container>
        <ContentHeader>
          <NavMenu>
            <Button onClick={handledOpenMenu}>
              <FiMenu size={24} color="#FF9b00" />
            </Button>

            <NavLink to="/checkout">
              {items_count > 0 && (
                <BadgeNumber number={1}>
                  <span>{items_count}</span>
                </BadgeNumber>
              )}
              <FiShoppingCart size={24} color="#FF9b00" />
            </NavLink>
          </NavMenu>
        </ContentHeader>
        <Content>
          {!openMenu && (
            <ContainerProducts>
              <ProductList />
            </ContainerProducts>
          )}
        </Content>
      </Container>
    </Root>
  );
};

export default MobileHome;
